export const catalog_matrix = [
  {form_key:'letter_status_id', catalog_key:'letter_statuses'},
  //{form_key:'responsible_id', catalog_key:'none', propname:'users'},
]